module.exports = __webpack_public_path__ + "img/picto-visites.d3cb6501.svg";